import Router from 'next/router';
import NProgress from 'nprogress';
import { useEffect } from 'react';

// Hook for displaying loading progress when route is changed
const useNProgress = () => {
  useEffect(() => {
    NProgress.configure({ parent: '#__next', showSpinner: false });
    Router.events.on('routeChangeStart', () => NProgress.start());
    Router.events.on('routeChangeComplete', () => NProgress.done());
    Router.events.on('routeChangeError', () => NProgress.done());
  }, []);
};

export default useNProgress;
